package pt.at.oss.kotlin.core.enumeration

/**
 * Created by Pedro Alfaiate on 01/06/2020.
 */

val EU_COUNTRIES = Country.values().filter { it.isInEU }

val NON_EU_COUNTRIES = Country.values().filter { !it.isInEU }

val EU_COUNTRIES_EXCEPT_PT = EU_COUNTRIES.filter { it != Country.PORTUGAL }
